// utils/wishlistUtils.ts

import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../redux/store";
import {
  addToWishlist,
  removeFromWishlist,
  toggleWishlistItem,
  clearWishlist,
} from "../redux/Wishlist/wishlistSlice";

const useWishlistActions = () => {
  const dispatch = useDispatch();
  const wishlistItems = useSelector((state: RootState) => state.wishlist.items);
  const totalItems = useSelector((state: RootState) => state.wishlist.totalItems);

  const addItem = (item: any) => {
    dispatch(addToWishlist(item));
  };

  const removeItem = (id: number | string) => {
    dispatch(removeFromWishlist(id));
  };

  const toggleItem = (item: any) => {
    dispatch(toggleWishlistItem(item));
  };

  const clearAll = () => {
    dispatch(clearWishlist());
  };

  const isInWishlist = (id: number | string) => {
    return wishlistItems.some((item: any) => item.id === id);
  };

  return { 
    addItem, 
    removeItem, 
    toggleItem, 
    clearAll, 
    isInWishlist,
    wishlistItems,
    totalItems
  };
};

export default useWishlistActions;
